export default "__VITE_ASSET__eF8zZhNd__"